<template>
	<div id="home-wallet">
		<div class="content-container">
			<div class="content-inner">
				<div class="container h-100">
					<div class="row wallet-row flex-sm-row-reverse align-items-center h-100">
						<div class="wallet-col col-md-12 col-lg-6 col-12 col-sm-12 d-flex flex-column align-items-end">
							<div class="title headline-l text-right">
	                                <span :style="titleStyle">{{ title || $t('homeScreen.wallet.title') }}</span>
							</div>
							<div class="text text-l text-right">
	                                <span :style="descriptionStyle">{{ description || $t('homeScreen.wallet.description') }}</span>
							</div>
							<div v-if="extraText" class="text extra-text text-l text-right">
	                                <span :style="extraTextStyle">{{ extraText }}</span>
							</div>
							<div v-if="!hideOpenWalletPrompt" class="text open-wallet text-l text-right">
								{{ $t('homeScreen.general.openWalletPrompt') }}
							</div>
							<div
								class="stores d-flex justify-content-center justify-content-lg-start"
							>
								<store-button :version="'apple'" />
								<store-button :version="'google'" />
							</div>
						</div>
					</div>
				</div>
				<div class="wallet-image-wrapper container">
					<img
						v-if="mobileImagePath"
						class="wallet-image d-lg-none"
						:src="mobileImagePath ? mobileImagePath : imagePath"
						alt="wallet phone mobile"
					/>
					<img
						class="wallet-image"
						:class="mobileImagePath ? 'd-none d-lg-block' : 'd-lg-block'"
						:src="imagePath || '/images/elements/home/web/home_phone.png'"
						alt="wallet phone"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HomeWallet',
	props: {
		title: {
			type: String,
			default: null,
		},
		description: {
			type: String,
			default: null,
		},
		extraText: {
			type: String,
			default: null,
		},
		titleStyle: {
			type: Object,
			default: () => ({}),
		},
		descriptionStyle: {
			type: Object,
			default: () => ({}),
		},
		extraTextStyle: {
			type: Object,
			default: () => ({}),
		},
		imagePath: {
			type: String,
			default: null,
		},
		mobileImagePath: {
			type: String,
			default: null,
		},
		hideOpenWalletPrompt: {
			type: Boolean,
			default: false,
		},
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {},
	methods: {
		handleButtonClick() {
			this.$router.push('/wallet');
		},
	},
};
</script>

<style lang="scss" scoped>
#home-wallet {
	min-height: 594px;
	display: flex;
	border-bottom: 1px solid #4b2eaa80;
	background-image: url('/images/elements/home/web/wallet_background_flipped.png');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	@media (max-width: $breakpoint-xs) {
		background-position: 60%;
	}
	.container {
		z-index: 1;
		@media (min-width: $breakpoint-lg) {
			max-width: 1196px;
		}
		.title {
			color: $black;
			margin-bottom: $margin-m;
			text-transform: uppercase;
			@media (max-width: $breakpoint-md) {
				text-align: center;
			}
			@media (min-width: $breakpoint-lg) {
				max-width: 540px;
			}
		}
		.main-image {
			margin-bottom: $margin-s;
		}
		.more-button {
			margin-bottom: $margin-m;
		}
		.text {
			margin-bottom: 20px;
			@media (max-width: $breakpoint-md) {
				text-align: center;
			}
			@media (min-width: $breakpoint-lg) {
				max-width: 540px;
			}
		}
		.extra-text {
			font-family: 'HKNova-SemiBold', sans-serif;
		}
		.open-wallet {
			font-family: 'HKNova-SemiBold', sans-serif;
			margin-top: $margin-m;
		}
		.stores {
			display: flex;
			align-items: center;

			.store-button {
				&:first-child {
					margin-right: 20px;
				}
			}
		}
	}
	.wallet-image-wrapper {
		position: absolute;
		height: 594px;
		justify-content: start;
		display: flex;
		margin-top: auto;
		z-index: 0;
		@media (max-width: $breakpoint-md) {
			position: relative;
			justify-content: center;
			min-height: 457px;
			height: unset;
		}
		@media (max-width: $breakpoint-md) {
			padding-top: 34px !important;
		}
	}
	.wallet-image {
		max-height: 532px;
		object-fit: contain;
		margin-top: auto;
		margin-bottom: -2px;
		@media (max-width: $breakpoint-md) {
			height: 100%;
			max-height: 457px;
		}
	}
	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		min-height: 594px;
		background: linear-gradient(270deg, #4b2eaa80, transparent 25%),
			rgba(232, 232, 255, 0.85);
		@media (max-width: $breakpoint-sm) {
			min-height: unset;
			height: 100%;
		}
		.content-inner {
			width: 100%;
			display: flex;
			height: 100%;
			flex-direction: column;
			align-items: center;
			z-index: 1;
			@media (max-width: $breakpoint-md) {
				padding-top: $margin-m !important;
			}
			.wallet-col {
				@media (max-width: $breakpoint-sm) {
					align-items: center !important;
					text-align: center;
					.text {
						text-align: center !important;
					}
					.title {
						text-align: center !important;
					}
				}
			}
		}
	}
}
@media (max-width: $breakpoint-sm) {
	#home-wallet {
		min-height: unset !important;
		.title {
			margin-bottom: $margin-s !important;
		}
		.open-wallet {
			text-align: center;
		}
	}
}
</style>
